import { EmptyState } from '@components/empty-state';
import { IconTextFormatLinkOff } from '@components/icons/text-format-link-off';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { useScopedTranslate } from '@locale/translate';

export const JourneyFormLoadError = () => {
  const { t } = useScopedTranslate(locale);
  return (
    <EmptyState
      header={t('header')}
      content={
        <Stack space={4}>
          <Text color="textSecondary" font="regular14" text={t('desc1')} />
          <Text color="textSecondary" font="regular14" text={t('desc2')} />
        </Stack>
      }
      icon={<IconTextFormatLinkOff size={80} />}
    />
  );
};

const locale = {
  en: {
    header: 'Link inactive',
    desc1: 'The form link you tried to reach is not accessible at the moment.',
    desc2: 'The owner may have disabled or removed it. Please contact them if you need access.',
  },
};
